import { render, staticRenderFns } from "./PlacementBookingApproveTableForm.vue?vue&type=template&id=3565b96e&scoped=true"
import script from "./PlacementBookingApproveTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementBookingApproveTableForm.vue?vue&type=script&lang=js"
import style0 from "./PlacementBookingApproveTableForm.vue?vue&type=style&index=0&id=3565b96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565b96e",
  null
  
)

export default component.exports